'use strict';

export default function joinFactory($rootScope, modal) {
  'ngInject';

  const USER_TYPE = 'guide';

  return {
    showModal: function () {
      const scope = $rootScope.$new();
      scope.userType = USER_TYPE;
      scope.newDesign = 'fbIntro';

      return modal.open({
        template: '<sa-join on-success="close(result)" user-type="{{userType}}" new-design="{{newDesign}}"></sa-join>',
        cssClass: 'FbLanding--Modal',
        scope: scope,
        destroyOnStateChange: true,
        closeOff: true
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/join_fb_landing.js